<template>
  <form class="form-modal-dialog">
    <b-table :data="data"
             :height="420"
             :mobile-cards="false"
             class="unbordered-table"
             :row-class="(row, index) => {
               return `${!LeadSource
               ? (row.LeadSource?'row-custom-background':'')
               :(row.LeadSource?(row.LeadSource.id
                !== LeadSource.id?'row-custom-background':''):'')}`
             }"
             v-slot="props"
             ref="leadSources">
      <b-table-column cell-class="cell" field="value">
        <div class="lead-distribution-set-title-wrapper">
          <span class="lead-distribution-set-title">{{ props.row.value }}</span>
        </div>
        <div v-if="props.row.LeadSource">
              <span v-if="!LeadSource
                          || (LeadSource
                              && (props.row.LeadSource.id !== LeadSource.id)
                              )" class="span-used-distribution-set">{{props.row.LeadSource.title}}
              </span>
        </div>
        <b-field class="template-selector-wrapper">
          <b-select class="control is-fullwidth template-selector"
                    @change.native="changeSelectedRows"
                    :leadSourceId="props.row.id">
              <option v-for="row in dataLeadDistribution"
                      :value="row.id"
                      :key="row.id">{{ row.title }}
              </option>
          </b-select>
        </b-field>
      </b-table-column>
    </b-table>
  </form>
</template>

<script>

export default {
  name: 'LeadSourceAssign',
  props: {
    value: {},
    blur: {},
    selectedRows: {
      type: Array,
      default: () => [],
    },
    LeadSource: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Array,
      default: () => [],
    },
    dataLeadDistribution: {
      type: Array,
      default: () => [],
    },
    row: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      mapSelectedRows: new Map(),
    };
  },
  methods: {
    changeSelectedRows(event) {
      const leadSourceId = event.target.attributes.getNamedItem('leadSourceId').value;
      const leadDistributionId = event.target.value;
      this.mapSelectedRows.set(leadSourceId, leadDistributionId);
      this.selectedRows.leadSources = [...this.mapSelectedRows].map((item) => ({
        leadSourceId: item[0],
        leadDistributionId: item[1],
      }));
    },
  },
};
</script>

<style scoped lang="stylus">
.field-set-name
  margin-bottom 20px
.form-modal-dialog >>> .field-set-name
  .custom-class-field-set-name
    font-weight 400
.template-selector-wrapper
    width 100%;
.template-selector >>> span
    width 100%
    select
        width 100%
.unbordered-table
  td:first-child
    border-left 0px solid rgba(143, 167, 179, 0.3)
    width 100%
    box-sizing border-box
  td:last-child
    border-right 0px solid rgba(143, 167, 179, 0.3)
    border-bottom 0px
    width 100%
    box-sizing border-box
    background-color unset
    flex-wrap wrap
    column-gap 5px
    justify-content end!important
    .lead-distribution-set-title {
        font-size 16px
        box-sizing border-box
        width 100%
    }
    .lead-distribution-set-title-wrapper
      white-space normal
.unbordered-table >>> table.table thead
  display none
.unbordered-table >>> td.checkbox-cell
  border-left 0px solid rgba(143,167,179,0.3)

.unbordered-table >>> tr.row-custom-background
  background-color #F2F2F2!important
.span-used-distribution-set
  color #525F66

.b-table >>> tbody tr:first-child td
  border-top 0px solid rgba(143,167,179,0.3)
  box-sizing border-box
  width 100%
</style>
